import { axios } from '../utils/axios';

import { AiPromptTemplate } from '../@types/ai';
import { IChatSession } from '../@types/chat';
import { Note, Transcription } from '../@types/notes-transcription';

export const startNotes = async (
  channelId: string,
  audioOnly?: boolean,
): Promise<{ document: Note }> => {
  const { data } = await axios.post<{ document: Note }>(
    `/chat/channel/voice/start-notes/${channelId}?audioOnly=${audioOnly}`,
  );
  return data;
};

export const stopNotes = async (channelId: string) => {
  const { data } = await axios.post(
    `/chat/channel/voice/stop-notes/${channelId}`,
  );
  return data;
};

export async function getPastNotesByChannelId(
  channelId: string,
): Promise<Note[]> {
  const { data } = await axios.get<Note[]>(
    `/chat/channel/voice/notes/${channelId}`,
  );
  return data;
}

type SessionsProps = {
  sessions: IChatSession[];
  notes: Note[];
};

export async function getPastSessionsByChannelId(
  channelId: string,
): Promise<SessionsProps> {
  const { data } = await axios.get<SessionsProps>(
    `/chat/channel/voice/sessions/${channelId}`,
  );
  return data;
}

export async function getTranscriptionById(
  transcriptionId: string,
): Promise<Transcription> {
  const { data } = await axios.get<Transcription>(
    `/chat/channel/voice/transcription/${transcriptionId}`,
  );
  return data;
}

export type UpdateSpeakerProps = {
  transcriptionId: string;
  speaker: number;
  paticipantRef: string;
};

export const updateSpeaker = async (
  params: UpdateSpeakerProps,
): Promise<Transcription> => {
  const { data } = await axios.put<Transcription>(
    '/chat/channel/voice/transcription/speaker',
    params,
  );
  return data;
};

export type AiProps = {
  transcriptionId: string;
  template: AiPromptTemplate;
  input?: string;
};

export const sendToAi = async (params: AiProps): Promise<{ text: string }> => {
  const { data } = await axios.post<{ text: string }>(
    '/chat/channel/voice/transcription/action',
    params,
  );
  return data;
};

export const sumarized = async (documentId: { documentId: string }) => {
  const { data } = await axios.patch(
    '/chat/channel/voice/transcription/summarized',
    documentId,
  );
  return data;
};

export * as NotesTranscriptionRequests from './notes-transcription';
